import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CustomerIOService } from './customer-io.service';
import { IN_APP_MESSAGE_ACTIONS } from './in-app-message-action.config';

/**
 * Runs the side effects declared in {@link IN_APP_MESSAGE_ACTIONS} whenever a
 * matching Customer.io in-app message action is taken. This lets us drive
 * in-app product behaviour (e.g. enabling Labs) straight from the Customer.io
 * composer, keyed by the action's `actionValue`.
 *
 * Instantiated eagerly from `AuthenticatedComponent`.
 */
@Injectable({ providedIn: 'root' })
export class InAppMessageActionService {
  #customerIo = inject(CustomerIOService);
  #handlers = inject(IN_APP_MESSAGE_ACTIONS);

  constructor() {
    this.#customerIo.inAppMessageActions$
      .pipe(takeUntilDestroyed())
      .subscribe((messageAction) => this.#dispatch(messageAction.actionValue));
  }

  #dispatch(actionValue: string): void {
    this.#handlers.filter((handler) => handler.actionValue === actionValue).forEach((handler) => handler.handle());
  }
}
